import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { DistrictService } from './district.service';
@Component({
  selector: 'app-district',
  templateUrl: './district.component.html',
  styleUrls: ['./district.component.scss']
})
export class DistrictComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'district', 'region', 'state', 'zone', 'country', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  districtForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();
  public searchInput = new FormControl("");

  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private districtService: DistrictService) {
    this.districtForm = this.fb.group({
      district: ['', Validators.required],
      country: ['', Validators.required],
      zone: ['', Validators.required],
      state: ['', Validators.required],
      region: ['', Validators.required],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.getCountryList();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.districtForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.getZoneList(object?.state?.country?.id);
    this.getStateList(object?.state?.zone?.id);
    this.getRegionList(object?.state?.id);
    this.districtForm.patchValue({
      country: object?.state?.country?.id,
      zone: object?.state?.zone?.id,
      state: object?.state?.id,
      region: object?.region?.id ? object?.region?.id : '',
      district: object.district_name,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const district = data.district_name.toLowerCase().includes(filter);
      return district;
    };
      this.dataSource.filter = filterValue;
  }

  clearSearch() {
    this.searchInput.setValue(''); // Clear the search input
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.districtForm.valid) {
      const districtData = this.districtForm.value;
      let obj = {
        "state_id": parseInt(districtData.state),
        "region_id": parseInt(districtData.region),
        "district_name": districtData.district,
        "status": parseInt(districtData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.districtService.createDistrict(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("District created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.districtForm.valid) {
      const districtData = this.districtForm.value;
      let obj = {
        "state_id": parseInt(districtData.state),
        "region_id": parseInt(districtData.region),
        "district_name": districtData.district,
        "status": parseInt(districtData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.districtService.updateDistrict(obj, this.selectedObject.id).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("District updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.districtForm.controls['region'].enable();
    this.districtForm.patchValue({
      country: '',
      zone: '',
      region: '',
      state: '',
      district: '',
      status: ''
    });
    this.zoneList = [];
    this.stateList = [];
    this.regionList = [];
    
  }

  allowNumbersHyphenOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9\-]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.districtService.getDistrict().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data        
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  countryList: any = []
  getCountryList() {
    this.districtService.getCountry().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.countryList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  zoneList: any = []
  getZoneList(countryId?: any) {
    this.zoneList = []
    let id: any = this.districtForm.value.country ? this.districtForm.value.country : countryId
    this.districtService.getZoneByCountry(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.zoneList = responseData.data;
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  stateList: any = []
  getStateList(zoneId?: any) {
    this.stateList = []
    this.regionList = []
    this.districtForm.patchValue({state:'',region:''})
    let id: any = this.districtForm.value.zone ? this.districtForm.value.zone : zoneId;
    this.districtService.getStateByZone(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.stateList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  regionList: any = []
  getRegionList(stateId?: any) {
    this.regionList = []
    this.districtForm.patchValue({region:''})
    let id: any = this.districtForm.value.state ? this.districtForm.value.state : stateId;
    this.districtService.getRegionByState(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.regionList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }
}
